module.exports = __webpack_public_path__ + "img/epr-price@2x.1c102375.jpeg";